module.exports = __webpack_public_path__ + "img/poll-banner.6144f87c.svg";